import { defineComponent as _defineComponent } from 'vue'
import NModel from '@/component/NModel/NModel.vue';
import router from '@/router';
import { useForm } from '@/util/useForm';
import moment from 'moment';
import { onActivated, ref } from 'vue';
import {
  addDiscount,
  getDiscountList,
  removeDiscount,
  removeMoreDiscount,
} from '@/api/marketing/discount';
import { message } from 'ant-design-vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Discount',
  setup(__props) {

const form = useForm();
const dataSource = ref<any>([]);
const reuseVisible = ref<boolean>(false); // 复用打开框
const selectedRowKeys = ref<any[]>([]); // 选中
const reuse_start_time = ref<any>(); // 复用开始时间
const reuse_end_time = ref<any>(); // 复用结束时间
const loading = ref<boolean>(false); // 表格加载
const queryParams = ref<any>({}); // 搜索条件
const stopVisible = ref<boolean>(false); // 停用框
const stopMoreVisible = ref<boolean>(false); // 批量停用框
const stopId = ref<any>(); // 停用当前行id
const disabledData = ref<any[]>([]);
const pagination = ref({
  current: 1,
  total: 1,
  limit: 10,
});
const total = ref<number>(); // 共计
const isAllSelected = ref<boolean>(false); // 全选
// 查询
async function queryActivity() {
  const { type, name, status } = form.value.getFormValue();
  queryParams.value = {
    type,
    name,
    status,
  };
  query({
    current: pagination.value.current,
    limit: pagination.value.limit,
    ...queryParams.value,
  });
}
async function query(params = queryParams.value) {
  const formatParams = {
    current: pagination.value.current,
    limit: pagination.value.limit,
    ...params,
  };
  loading.value = true;
  dataSource.value = [];
  const res: any = await getDiscountList(formatParams);
  loading.value = false;
  dataSource.value = res?.data?.detail;
  disabledData.value = dataSource.value.filter(item => {
    return item.status == 3;
  });
  total.value = res.data.total;
}
query();
// 清除搜索条件
function clear() {
  form.value.resetFields();
  queryActivity();
}
// 禁用没有停用功能的数据选中
function getCheckboxProps(record) {
  if (disabledData.value.includes(record)) {
    return {
      props: {
        disabled: true,
        name: record.name,
      },
    };
  }
  return {
    props: {
      disabled: false,
      name: record.name,
    },
  };
}
// 全选框
function onSelectAllRows(e) {
  isAllSelected.value = e.target.checked;
  if (isAllSelected.value) {
    selectedRowKeys.value = dataSource.value?.filter(i => i.status !== 3).map(item => item.id);
  } else {
    selectedRowKeys.value = [];
  }
}
// 新建
function addDiscountAct() {
  router.push('/marketing/add-discount');
}

// 停用
function stop(record) {
  stopVisible.value = true;
  stopId.value = record.id;
}
// 停用确认
async function onStopOk() {
  const res: any = await removeDiscount(stopId.value);
  if (res.status == 200) {
    message.success('停用成功');
    stopVisible.value = false;
    query();
  } else {
    message.error(res?.message);
    stopVisible.value = false;
  }
}

// 批量操作-停用
// 批量停用确认
async function onStopMoreOk() {
  const arr = [];

  const res: any = await removeMoreDiscount({
    id: selectedRowKeys.value.map(item => String(item)),
  });
  if (res.status == 200) {
    message.success('停用成功');
    stopMoreVisible.value = false;
    selectedRowKeys.value = [];
    query();
  } else {
    message.error(res?.message);
    stopMoreVisible.value = false;
  }
}

// 表格改变
function onTableChange(current) {
  query({ ...queryParams.value, current });
}
function onSelectChange(selectedRow) {
  selectedRowKeys.value = selectedRow;
  if (selectedRowKeys.value.length == dataSource.value.length) {
    isAllSelected.value = true;
  } else {
    isAllSelected.value = false;
  }
}
// 改变每页显示条目
function onShowSizeChange(current, pageSize) {
  pagination.value.limit = pageSize;
  query({ ...queryParams.value, current: 1 });
}
// 换页
function onChangePage(page) {
  pagination.value.current = page;
  query({ ...queryParams.value, current: pagination.value.current, limit: pagination.value.limit });
  selectedRowKeys.value = [];
  isAllSelected.value = false;
}
// 编辑
function onEdit(record) {
  router.push({ path: `/marketing/edit-discount?id=${record.id}` });
}
/**
 * 复用
 */
const reuseValue = ref<any>();
function reuse(record) {
  reuseVisible.value = true;
  reuseValue.value = record;
}
// 复用-确认
async function reuseOk() {
  const product_list = reuseValue.value.product.map(({ id, sort }) => ({ id, sort }));
  const send_data = {
    name: reuseValue.value.name,
    type: reuseValue.value.type,
    superposition: reuseValue.value.superposition,
    threshold_price: reuseValue.value.threshold_price,
    discounts_minus: reuseValue.value.discounts_minus,
    discounts_ratio: reuseValue.value.discounts_ratio,
    start_time: +moment(reuse_start_time.value).format('X'),
    end_time: +moment(reuse_end_time.value).format('X'),
    product_list,
  };
  const res = await addDiscount(send_data);
  if (res.status !== 200) {
    message.error((res as any).message);
    return;
  }
  message.success('复用成功');
  reuseVisible.value = false;
}
// 复用-取消
function reuseCancle() {
  reuseVisible.value = false;
  reuse_start_time.value = null;
  reuse_end_time.value = null;
}
// 复用-禁用今天之前的日期
function disabledDate(current) {
  return current && current < moment().startOf('day');
}
// 日期格式
function Format(time) {
  return moment(time * 1000).format('YYYY/MM/DD HH:mm:ss');
}
onActivated(() => {
  query();
});

return { __sfc: true,form, dataSource, reuseVisible, selectedRowKeys, reuse_start_time, reuse_end_time, loading, queryParams, stopVisible, stopMoreVisible, stopId, disabledData, pagination, total, isAllSelected, queryActivity, query, clear, getCheckboxProps, onSelectAllRows, addDiscountAct, stop, onStopOk, onStopMoreOk, onTableChange, onSelectChange, onShowSizeChange, onChangePage, onEdit, reuseValue, reuse, reuseOk, reuseCancle, disabledDate, Format, NModel, moment }
}

})